export enum TranslationLanguageEnum {
  Albanian = "Albanian",
  Amharic = "Amharic",
  Arabic = "Arabic",
  Armenian = "Armenian",
  Bengali = "Bengali",
  Bosnian = "Bosnian",
  Bulgarian = "Bulgarian",
  Burmese = "Burmese",
  Catalan = "Catalan",
  Chinese = "Chinese",
  Croatian = "Croatian",
  Czech = "Czech",
  Danish = "Danish",
  Dutch = "Dutch",
  English = "English",
  Estonian = "Estonian",
  Finnish = "Finnish",
  French = "French",
  Georgian = "Georgian",
  German = "German",
  Greek = "Greek",
  Gujarati = "Gujarati",
  Hindi = "Hindi",
  Hungarian = "Hungarian",
  Icelandic = "Icelandic",
  Indonesian = "Indonesian",
  Italian = "Italian",
  Japanese = "Japanese",
  Kannada = "Kannada",
  Kazakh = "Kazakh",
  Korean = "Korean",
  Latvian = "Latvian",
  Lithuanian = "Lithuanian",
  Macedonian = "Macedonian",
  Malay = "Malay",
  Malayalam = "Malayalam",
  Marathi = "Marathi",
  Mongolian = "Mongolian",
  Norwegian = "Norwegian",
  Persian = "Persian",
  Polish = "Polish",
  Portuguese = "Portuguese",
  Punjabi = "Punjabi",
  Romanian = "Romanian",
  Russian = "Russian",
  Serbian = "Serbian",
  Slovak = "Slovak",
  Slovenian = "Slovenian",
  Somali = "Somali",
  Spanish = "Spanish",
  Swahili = "Swahili",
  Swedish = "Swedish",
  Tagalog = "Tagalog",
  Tamil = "Tamil",
  Telugu = "Telugu",
  Thai = "Thai",
  Turkish = "Turkish",
  Ukrainian = "Ukrainian",
  Urdu = "Urdu",
  Vietnamese = "Vietnamese",
}

export const getTranslateEnumByLocale = (locale: string) => {
  // 获取locale前缀
  const prefix = locale.split("-")[0];
  switch (prefix) {
    case "sq":
      return TranslationLanguageEnum.Albanian;
    case "am":
      return TranslationLanguageEnum.Amharic;
    case "ar":
      return TranslationLanguageEnum.Arabic;
    case "hy":
      return TranslationLanguageEnum.Armenian;
    case "bn":
      return TranslationLanguageEnum.Bengali;
    case "bs":
      return TranslationLanguageEnum.Bosnian;
    case "bg":
      return TranslationLanguageEnum.Bulgarian;
    case "my":
      return TranslationLanguageEnum.Burmese;
    case "ca":
      return TranslationLanguageEnum.Catalan;
    case "zh":
      return TranslationLanguageEnum.Chinese;
    case "hr":
      return TranslationLanguageEnum.Croatian;
    case "cs":
      return TranslationLanguageEnum.Czech;
    case "da":
      return TranslationLanguageEnum.Danish;
    case "nl":
      return TranslationLanguageEnum.Dutch;
    case "et":
      return TranslationLanguageEnum.Estonian;
    case "fi":
      return TranslationLanguageEnum.Finnish;
    case "fr":
      return TranslationLanguageEnum.French;
    case "ka":
      return TranslationLanguageEnum.Georgian;
    case "de":
      return TranslationLanguageEnum.German;
    case "el":
      return TranslationLanguageEnum.Greek;
    case "gu":
      return TranslationLanguageEnum.Gujarati;
    case "hi":
      return TranslationLanguageEnum.Hindi;
    case "hu":
      return TranslationLanguageEnum.Hungarian;
    case "is":
      return TranslationLanguageEnum.Icelandic;
    case "id":
      return TranslationLanguageEnum.Indonesian;
    case "it":
      return TranslationLanguageEnum.Italian;
    case "ja":
      return TranslationLanguageEnum.Japanese;
    case "kn":
      return TranslationLanguageEnum.Kannada;
    case "kk":
      return TranslationLanguageEnum.Kazakh;
    case "ko":
      return TranslationLanguageEnum.Korean;
    case "lv":
      return TranslationLanguageEnum.Latvian;
    case "lt":
      return TranslationLanguageEnum.Lithuanian;
    case "mk":
      return TranslationLanguageEnum.Macedonian;
    case "ms":
      return TranslationLanguageEnum.Malay;
    case "ml":
      return TranslationLanguageEnum.Malayalam;
    case "mr":
      return TranslationLanguageEnum.Marathi;
    case "mn":
      return TranslationLanguageEnum.Mongolian;
    case "no":
      return TranslationLanguageEnum.Norwegian;
    case "fa":
      return TranslationLanguageEnum.Persian;
    case "pl":
      return TranslationLanguageEnum.Polish;
    case "pt":
      return TranslationLanguageEnum.Portuguese;
    case "pa":
      return TranslationLanguageEnum.Punjabi;
    case "ro":
      return TranslationLanguageEnum.Romanian;
    case "ru":
      return TranslationLanguageEnum.Russian;
    case "sr":
      return TranslationLanguageEnum.Serbian;
    case "sk":
      return TranslationLanguageEnum.Slovak;
    case "sl":
      return TranslationLanguageEnum.Slovenian;
    case "so":
      return TranslationLanguageEnum.Somali;
    case "es":
      return TranslationLanguageEnum.Spanish;
    case "sw":
      return TranslationLanguageEnum.Swahili;
    case "sv":
      return TranslationLanguageEnum.Swedish;
    case "tl":
      return TranslationLanguageEnum.Tagalog;
    case "ta":
      return TranslationLanguageEnum.Tamil;
    case "te":
      return TranslationLanguageEnum.Telugu;
    case "th":
      return TranslationLanguageEnum.Thai;
    case "tr":
      return TranslationLanguageEnum.Turkish;
    case "uk":
      return TranslationLanguageEnum.Ukrainian;
    case "ur":
      return TranslationLanguageEnum.Urdu;
    case "vi":
      return TranslationLanguageEnum.Vietnamese;
    case "en":
    default:
      return TranslationLanguageEnum.English;
  }
};
